import _defineProperty from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import request from "@/utils/request";
import { EventBus } from "@/api/event-bus";
export default _defineProperty(_defineProperty({
  name: "Weforsys-table-draggable",
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columnData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 序号 默认有
    hasNO: {
      type: Boolean,
      default: true
    },
    // 多选框 默认无
    hasC: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: Number
    },
    pageSize: {
      type: Number
    },
    height: {
      default: "100%"
    },
    reftext: {
      default: "WeforsysTable"
    },
    changetext: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bindings: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    changeparameter: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    col: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dropCol: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onlyid: {
      default: ""
    },
    transvalue: {
      default: ""
    }
  },
  filters: {
    getName: function getName(id, industryTypeList) {
      var item = industryTypeList.filter(function (o) {
        return o.enCode == id;
      })[0];
      return item && item.fullName ? item.fullName : "";
    },
    dynamicTexts: function dynamicTexts(id, industryTypeList) {
      var item = industryTypeList.filter(function (o) {
        return o.id == id;
      })[0];
      return item && item.fullName ? item.fullName : "";
    }
  },
  data: function data() {
    return {
      datas: [],
      pageConfig: [],
      collist: [],
      visibles: false,
      numbers: 0
    };
  },
  created: function created() {
    this.initData();
    EventBus.$on("executeMethod", this.getColumnWidths);
  },
  beforeDestroy: function beforeDestroy() {
    EventBus.$off("executeMethod", this.getColumnWidths);
  },
  activated: function activated() {
    var _this = this;
    // 解决缓存出现的表格错位问题
    this.$nextTick(function () {
      _this.$refs.WeforsysTable.doLayout();
    });
  },
  mounted: function mounted() {},
  watch: {
    data: {
      handler: function handler(val) {
        if (!val) return;
        this.doLayout();
      },
      deep: true
    },
    columnData: {
      handler: function handler(val) {
        if (!val) return;
        this.doLayout();
      },
      deep: true
    }
  }
}, "activated", function activated() {
  var _this2 = this;
  // 解决缓存出现的表格错位问题
  this.$nextTick(function () {
    _this2.$refs[_this2.reftext].doLayout();
  });
}), "methods", {
  allConditionsNotMet: function allConditionsNotMet(row, rows) {
    var stast = false;
    row.forEach(function (element) {
      if (rows == element) {
        stast = true;
      }
    });
    return stast;
  },
  setup: function setup() {
    this.visibles = true;
  },
  getColumnWidths: function getColumnWidths() {
    var _this3 = this;
    var columnWidths = [];
    this.$nextTick(function () {
      var headers = _this3.$refs[_this3.reftext].store.states.columns;
      var arr = [];
      console.log(headers, "headers");
      headers.forEach(function (header) {
        var width = 0;
        _this3.pageConfig.forEach(function (element) {
          if (element.Columns == header.label) {
            if (header.realWidth == null) {
              element.Width = Math.floor(header.width);
            } else {
              element.Width = Math.floor(header.realWidth);
            }
          }
        });
      });
      EventBus.$emit("customEvent", {
        message: _this3.pageConfig
      });
    });
  },
  initData: function initData() {
    var _this4 = this;
    request({
      url: "/api/WMS/TableAdjustmentConfig/SelectTableAdjustmentConfig?pageType=".concat(this.transvalue),
      method: "get"
    }).then(function (res) {
      _this4.pageConfig = [];
      if (res.data.length == 0) {
        _this4.col.forEach(function (element) {
          _this4.pageConfig.push({
            Columns: element.label,
            Index: "true"
          });
        });
      } else {
        _this4.pageConfig = res.data;
      }
      console.log(_this4.pageConfig, "this.pageConfig ");
      _this4.collist = [];
      if (_this4.pageConfig[0] != undefined) {
        _this4.pageConfig.forEach(function (element) {
          _this4.col.forEach(function (elements) {
            if (element.Columns == elements.label && element.Index == "true") {
              _this4.collist.push({
                label: element.Columns,
                prop: elements.prop,
                Width: element.Width,
                Index: element.Index
              });
            }
          });
        });
      } else {
        _this4.pageConfig = [];
      }
    });
  },
  changes: function changes(newWidth, oldWidth, column, event) {
    this.getColumnWidths();
  },
  save: function save(row, rows) {
    var _this5 = this;
    if (this.pageConfig.length == 0) {
      this.col.forEach(function (element, index) {
        _this5.pageConfig.push({
          Columns: row[index],
          Width: rows[index],
          Index: "true"
        });
      });
    } else {
      this.pageConfig.forEach(function (element, index) {
        //
        if (_this5.hasC == false) {
          element.Width = rows[index];
        } else {
          element.Width = rows[index + 1];
        }
      });
    }
  },
  indexMethod: function indexMethod(index) {
    if (this.currentPage != undefined && this.pageSize != undefined) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    } else {
      return index + 1;
    }
  },
  doLayout: function doLayout() {
    var _this6 = this;
    setTimeout(function () {
      _this6.$nextTick(function () {
        _this6.$refs[_this6.reftext].doLayout();
      });
    }, 50);
  }
});